export default __webpack_public_path__ + "static/media/step3.01bdfc96.svg";